import React from "react";

import type { HeaderGroup } from "react-table";
import { TableSortLabel, TableRow, TableHead, TableCell } from "@material-ui/core";

type DefaultTableHeaderProps<T extends object> = {
    headerGroups: Array<HeaderGroup<T>>;
};

/** Conveinience class to render a default, sortable, potentially multi-level table header */
export const DefaultTableHeader = <T extends object>({ headerGroups }: DefaultTableHeaderProps<T>) => (
    <TableHead component="div">
        {headerGroups.map((headerGroup) => {
            return (
                <TableRow
                    key={headerGroup.getHeaderGroupProps().key}
                    component="div"
                    {...headerGroup.getHeaderGroupProps()}
                >
                    {headerGroup.headers.map((column, columnIndex) => (
                        <TableCell key={columnIndex} component="div" {...column.getHeaderProps()} align={column.align}>
                            {column.canSort ? (
                                <TableSortLabel
                                    active={column.isSorted}
                                    direction={column.isSortedDesc ? "desc" : "asc"}
                                    {...column.getSortByToggleProps()}
                                >
                                    {column.render("Header")}
                                </TableSortLabel>
                            ) : (
                                column.render("Header")
                            )}
                        </TableCell>
                    ))}
                </TableRow>
            );
        })}
    </TableHead>
);
